import SsoSettingsPage from './SsoSettingsPage'

interface IAddSSOMembersModalProps {
  setShowModal: (show: boolean) => void
}

function AddSSOMembersModal(props: IAddSSOMembersModalProps) {
  const { setShowModal } = props

  const closeModal = () => {
    setShowModal(false)
  }

  return (
    <div className="bg-black bg-opacity-50 absolute top-0 left-0 w-full h-full z-50" onClick={() => closeModal()}>
      <div
        className="fixed top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 bg-modalBackground rounded-lg p-6 max-h-[80%] w-[40%] overflow-y-auto border dark:border-gray-600"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="flex justify-center">
          <p className="text-2xl font-semibold">Configure Single Sign On</p>
        </div>
        <SsoSettingsPage />
      </div>
    </div>
  )
}

export default AddSSOMembersModal
